const COLLECTIVE_HEALTH_COM = 'collectivehealth.com';

// Store constants in an immutable array so consumers of the package can't
// accidentally change the behavior of this package.
const DOMAINS = Object.freeze([COLLECTIVE_HEALTH_COM, 'i.cchh.io']);

// Generate the base URL for a portal by following the CH conventions for those
// URLs. Intentionally provides some flexibility
function getBaseUrl({
  domain = COLLECTIVE_HEALTH_COM,
  env = 'local',
  host,
  port,
  protocol,
  subdomain,
}) {
  // Without a subdomain, we're typically going to be running on `localhost` or
  // similar. For those reasons, we assume this is a local URL and require the
  // port to be specified.
  if (!subdomain) {
    return `${protocol || 'http'}://${host}:${port}`;
  }

  // Prod is a special case where we only need/want to include the subdomain.
  if (env === 'prod') {
    return `https://${subdomain}.${COLLECTIVE_HEALTH_COM}`;
  }

  if (!DOMAINS.includes(domain)) {
    const supportedDomains = DOMAINS.join(', ');
    throw new Error(
      `${domain} is not a supported domain, must be one of: ${supportedDomains}.`
    );
  }

  // For local, we allow everything to be specified and again require the port.
  if (env === 'local') {
    return `${protocol || 'http'}://${subdomain}.${env}.${domain}:${port}`;
  }

  // Now that the special cases are out of the way, we can generate a URL which
  // supports our other non-special cases. We will typically see a 3-part domain
  // here made up of subdomain, environment, and the super domain. In most
  // cases, the super domain is collectivehealth.com, but it can also be
  // i.cchh.io for some others. This catch-all branch allows good flexibility.
  return `${protocol || 'https'}://${subdomain}.${env}.${domain}`;
}

module.exports = getBaseUrl;
module.exports.getBaseUrl = getBaseUrl;

// Expose constants in an immutable object so consumers of the package can't
// accidentally change the behavior of this package.
module.exports.constants = Object.freeze({
  DOMAINS,
});
